import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { Layout } from "./components/common/Layout"
import { Home } from "./pages/Home"
import { BlogSinglePage } from "./components/common/BlogSinglePage"
import { About } from "./pages/About"
import { Courses } from "./pages/Courses"
import { Blog } from "./pages/Blog"
import { OurApp } from "./pages/OurApp"
import { ContactUs } from "./pages/ContactUs"
import { UserBioForm } from "./pages/UserBio"
import { GalleryPage } from "./pages/Gallery"
import { NewsUpdatesPage } from "./pages/NewsUpdatesPage";
import { NewsDetailPage } from "./pages/NewsDetailPage";
import { CourseDetail } from "./pages/CourseDetail";
import { auth } from './firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';


function App() {
  const defaultEmail = 'mavenwechuli@gmail.com'; // Replace with your default user's email
  const defaultPassword = '123456'; //
  useEffect(() => {
    // Automatically sign in the default user
    const autoSignIn = async () => {
      try {
        const userCredential = await signInWithEmailAndPassword(auth, defaultEmail, defaultPassword);
        console.log("User signed in:", userCredential.user);
      } catch (error) {
        console.error("Error signing in:", error.message);
      }
    };

    autoSignIn();
  }, []);
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path='/'
            element={
              <Layout>
                <Home />
              </Layout>
            }
          />
          <Route
            path='/about'
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path='/courses'
            element={
              <Layout>
                <Courses />
              </Layout>
            }
          />
          <Route
            path='/our-app'
            element={
              <Layout>
                <OurApp />
              </Layout>
            }
          />
          <Route
            path='/contact'
            element={
              <Layout>
                <ContactUs />
              </Layout>
            }
          />
          <Route
            path='/onboard'
            element={
              <Layout>
                <UserBioForm />
              </Layout>
            }
          />
          <Route
            path='/blog'
            element={
              <Layout>
                <Blog />
              </Layout>
            }
          />
          <Route
            path='/single-blog'
            element={
              <Layout>
                <BlogSinglePage />
              </Layout>
            }
          />
          <Route
            path='/gallery'
            element={
              <Layout>
                <GalleryPage />
              </Layout>
            }
          />
          <Route
            path='/news'
            element={
              <Layout>
                <NewsUpdatesPage />
              </Layout>
            }
          />  
          <Route
            path='/news/:id'
            element={
              <Layout>
                <NewsDetailPage />
              </Layout>
            }
          />
          <Route
            path='/course/:id'
            element={
              <Layout>
                <CourseDetail />
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
